import { config } from "../../config/app-config";
import { ROUTES } from "../../routes/paths";

/**
 * True when the current location is an auth route (a login page or handoff).
 *
 * basename is a deploy knob (config.router.basename), and location.pathname
 * includes it, so strip it before comparing against the ROUTES constants.
 *
 * In its own module (not the dialog .tsx) so the component file exports only
 * its component — a React Fast Refresh requirement.
 */
export function onAuthRoute(): boolean {
  const basename = (config.router?.basename || "/").replace(/\/+$/, "");
  let path = window.location.pathname;
  if (basename && path.startsWith(basename)) path = path.slice(basename.length);
  if (!path.startsWith("/")) path = `/${path}`;
  return (
    path === ROUTES.AUTH.LOGIN ||
    path === ROUTES.AUTH.HANDOFF ||
    path === ROUTES.AUTH.ACCUR8_LOGIN
  );
}
